import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import withExtensions from '../../../extensions';
import withToggle from '../../../hoc/WithToggle';
import { getIsFormValid, getUser, isSuccess } from '../selectors';
import { updateCustomerInfo, clearSuccess } from '../actions';
import { getBrandName } from '../../../brands/selectors';
import { prependLocationPrefix } from '../../../utils/routes';

export default compose(
  withRouter,
  withExtensions,
  withToggle,
  connect(
    (state, ownProps) => ({
      brandRoute: ownProps.params.brandRoute,
      customerId: ownProps.params.customerId,
      customerName: ownProps.location.query.firstName,
      brandName: getBrandName(state, ownProps.params.brandRoute),
      subscriptionId: ownProps.location.query.subscription,
      formDisabled: !getIsFormValid(state),
      user: getUser(state),
      isSuccess: isSuccess(state),
    }), { updateCustomerInfo, clearSuccess }
  ),
  withHandlers({
    confirmSetup: props => async (token) => {
      await props.updateCustomerInfo(props.customerId, props.user, token, props.subscriptionId);
      props.off();
    },
    onSuccess: props => () => {
      props.clearSuccess();
      props.router.push(prependLocationPrefix('/'));
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchExtension(this.props.brandRoute);
    },
  }),
);



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/containers/UpdateCustomerInfoContainer.jsx